import { useEffect, useMemo } from "react";
import Intercom, { shutdown } from "@intercom/messenger-js-sdk";
import useGetIntercomToken from "hooks/useGetIntercomToken";
import UserService from "services/UserService";
import { useLocation } from "react-router-dom";
import Constants from "config/Constants";
import useRole from "providers/RoleProvider/useRole";

const routesToShowLauncher = [
  "/dashboards",
  Constants.routes.athletes.route,
  Constants.routes.groups.route,
  Constants.routes.exerciseLibrary.route,
  "/workouts",
  Constants.routes.exportData.route,
  Constants.routes.settings.route,
] as const;

const hideLauncherParams = ["view=fullscreen"];

function IntercomProvider() {
  const { pathname, search } = useLocation();
  const { data: hmac } = useGetIntercomToken(true);
  const role = useRole();
  const user = UserService.currentUser;

  /** Check if the current route is **NOT** in the list of routes to hide the launcher */
  const hideLauncher = useMemo(() => {
    if (pathname === "/") return false;
    if (search) {
      if (hideLauncherParams.some((param) => search.includes(param))) return true;
    }
    return !routesToShowLauncher.some((route) => pathname.startsWith(route));
  }, [pathname, search]);

  useEffect(() => {
    if (user && user.email && hmac) {
      Intercom({
        app_id: process.env.REACT_APP_INTERCOM_APP_ID!,
        user_id: user.uid,
        email: user.email,
        user_hash: hmac,
        hide_default_launcher: hideLauncher,
        custom_launcher_selector: "#intercom-launcher",
        /** Custom attributes we send to Intercom */
        user_role: role,
      });
    }

    return () => {
      shutdown();
    };
  }, [hideLauncher, hmac, user, role]);

  return null;
}

export default IntercomProvider;
